import React, { useMemo } from 'react';
import { TaskContext, TaskContextProps, taskSlice } from '../context/TaskContext';
import { Task } from '../types/task';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface TaskProviderProps {
  children: React.ReactNode;
}

export default function TaskProvider({ children }: TaskProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.tasks.items);
  const loading = useAppSelector(state => state.tasks.loading);

  const tasks = useMemo(() => {
    return new Map(items.map(item => [item.id, new Task(item)]));
  }, [items]);

  const taskContext: TaskContextProps = {
    tasks,
    tasksLoading: loading,
    setTasks: (tasks: Map<string, Task>) => dispatch(taskSlice.actions.set([...tasks.values()])),
  };

  return <TaskContext.Provider value={taskContext}>{children}</TaskContext.Provider>;
}
